import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../services/utility.service';

@Component({
    selector: 'home-component',
    templateUrl: 'home.component.html',
    styles: [
        `
        .card {
            box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
            transition: 0.3s;
            max-height: 300px;
        }
        
        .card:hover {
            box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        }
        
        .container {
            padding: 2px 16px;
        }
        `
    ]
})
export class HomeComponent {

    canLoad = false;

    pages = [
        {
            name: 'Industries',
            link: '/services/industries',
            description: 'Manage Industries',
            img: '/assets/imgs/industries.jpg',
        },
        {
            name: 'Vendors',
            link: '/services/vendors',
            description: 'Manage Vendors',
            img: '/assets/imgs/vendors.jpg',
        },
        {
            name: 'Services',
            link: '/services/nodes',
            description: 'Monitor Microservices',
            img: '/assets/imgs/gear.png',
        },
        {
            name: 'Notification',
            link: '/services/notification',
            description: 'Manage notifications',
            img: '/assets/imgs/notification.jpg',
        },
        {
            name: 'Featured Partners',
            link: '/services/featured-partners',
            description: 'Manage Featured Partners',
            img: '/assets/imgs/notification.jpg',
        },
    ];

    constructor(private auth: AuthenticationService, private util: UtilityService, private router: Router) {
        this.util.setTitle('Teradix Admin');

        this.auth.isAuthenticated()
            .then(() => {
                this.canLoad = true;
            })
            .catch(() => this.router.navigate(['login']));
    }
}
